<script lang="ts">
  import { computed, defineComponent } from "vue";

  export default defineComponent({
    props: {
      src: {
        type: String,
        required: true,
      },
      shape: {
        type: String,
        default: "circle",
      },
      size: {
        type: Number,
        default: 36,
      },
      name: {
        type: String,
        required: true,
      },
      suffix: {
        type: Boolean,
        default: true,
      },
      cutLength: {
        type: Number,
        default: 2,
      },
      color: {
        type: String,
        default: "#2F78FF",
      },
      fontSize: {
        type: String,
        default: null,
      },
    },
    setup(props) {
      const userName = computed(() => {
        const str = props.name || "";
        if (str.length > props.cutLength) {
          return props.suffix ? str.substr(str.length - props.cutLength) : str.substr(0, props.cutLength);
        }
        return str;
      });
      const avatarStyle = computed(() => {
        const sizeRem = `${props.size / 16}rem`;
        const fontSizeRem = "1.125rem";
        return {
          width: sizeRem,
          height: sizeRem,
          lineHeight: sizeRem,
          fontSize: props.fontSize || fontSizeRem,
        };
      });

      return {
        userName,
        avatarStyle,
      };
    },
  });
</script>

<template>
  <div class="avatar">
    <a-avatar v-if="src" :src="src" :shape="shape as any" :style="avatarStyle" />
    <a-avatar v-else class="def-avatar" :shape="shape as any" :style="{ ...avatarStyle, background: color }">
      {{ userName }}
    </a-avatar>
  </div>
</template>

<style lang="less" scoped>
  .def-avatar {
    color: #fff;

    &.ant-avatar-square {
      white-space: pre-wrap;
      border-radius: 4px;

      :deep(.ant-avatar-string) {
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        padding: 6px 8px;
        line-height: 18px;
        transform: none !important;
      }
    }
  }
</style>
